var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-mix-background"},[_c('img',{ref:"logoRef",attrs:{"src":_vm.logo,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }